<template>
    <div class="container">
        <vue-headful
                title="Sustateam - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3>Susteam</h3>
                            </div>
                            <div class="col text-md-right">
                                <router-link :to="{name: 'website-susteams-add'}" class="btn my-4 btn-primary">
                                    ADD Sustateam
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">First Name</th>
                                <th scope="col">Last Name</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="susteam in SusteamsDetails" :key="susteam.id">
                                <td>
                                    <button @click="deleteSusteam(susteam.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Idea"></button>
                                    <router-link :to="{name: 'website-susteams-update', params: {susteam_id: susteam.id}}" class="btn btn-info fas fa-pen"
                                            data-toggle="tooltip" data-placement="top" title="Edit Idea"></router-link>
                                </td>
                                <td>
                                    {{susteam.first_name}}
                                </td>
                                <td>
                                    {{susteam.last_name}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      SusteamsDetails: {},
      DepartmentsDetails: {}
    };
  },
  methods: {
    wip: function() {
      alert("Work in progress");
    },
    get_Susteams() {
      axios({
        url:
          "admin/sus-team/team/all" +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.SusteamsDetails = result.data.team;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    get_Departments() {
      axios({
        url:
          "admin/sus-team/department/all" +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.DepartmentsDetails = result.data.department;
            console.log(result.data.department);
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteSusteam(id) {
      axios({
        method: "delete",
        url:
          "admin/sus-team/team/delete/" +
          id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Team Member Deleted Successfully", "", "success");
            this.get_Susteams(1);
            result;
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  },
  mounted: function() {
    this.get_Departments();
    this.get_Susteams();
  }
};
</script>
<style>
</style>
